import React from 'react';

const MortgageLoanTypeFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1372_8754)">
      <path
        d="M4.66665 14.9999L2.99998 13.3333L1.33331 14.9999"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 18.6666H4.33333C3.97971 18.6666 3.64057 18.5261 3.39052 18.2761C3.14048 18.026 3 17.6869 3 17.3333V13.3333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_1372_8754)">
      <path d="M15.3333 5L17 6.66667L18.6666 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3333 1.33325H15.6666C16.0203 1.33325 16.3594 1.47373 16.6095 1.72378C16.8595 1.97382 17 2.31296 17 2.66659V6.66658"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip2_1372_8754)">
      <path
        d="M15.8334 10.8333H12.5C12.279 10.8333 12.067 10.921 11.9108 11.0773C11.7545 11.2336 11.6667 11.4456 11.6667 11.6666V18.3333C11.6667 18.5543 11.7545 18.7662 11.9108 18.9225C12.067 19.0788 12.279 19.1666 12.5 19.1666H17.5C17.721 19.1666 17.933 19.0788 18.0893 18.9225C18.2456 18.7662 18.3334 18.5543 18.3334 18.3333V13.3333L15.8334 10.8333Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 11V14H18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <g clipPath="url(#clip3_1372_8754)">
      <path
        d="M1.25 3.74992L5 0.833252L8.75 3.74992V8.33325C8.75 8.55427 8.6622 8.76623 8.50592 8.92251C8.34964 9.07879 8.13768 9.16659 7.91667 9.16659H2.08333C1.86232 9.16659 1.65036 9.07879 1.49408 8.92251C1.3378 8.76623 1.25 8.55427 1.25 8.33325V3.74992Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.75 9.16667V5H6.25V9.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1372_8754">
        <rect width="8" height="8" fill="white" transform="translate(0 12)" />
      </clipPath>
      <clipPath id="clip1_1372_8754">
        <rect width="8" height="8" fill="white" transform="translate(12)" />
      </clipPath>
      <clipPath id="clip2_1372_8754">
        <rect width="10" height="10" fill="white" transform="translate(10 10)" />
      </clipPath>
      <clipPath id="clip3_1372_8754">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MortgageLoanTypeFilterIcon;
